/**
 * handlerRegistry - the callbacks multiplayer.js registers for host/user
 * actions (moderation, lobby decisions, presenter commands, role changes,
 * thumbs up). They are functions, so they live OUTSIDE the stores (store
 * state stays serializable data); React event handlers read them at call
 * time via getHandlers().
 *
 * multiplayerUI's register* exports write here; registration order is
 * unchanged from the imperative UI (multiplayer.js registers during init,
 * before any of these can be clicked).
 */

export interface ModerationHandlers {
  onAction(action: string, targetActorNr: number, targetName: string): void | Promise<void>;
  onToggleLock(locked: boolean): boolean | Promise<boolean>;
}

export interface LobbyHandlers {
  onDecision(action: 'admit' | 'deny', entryRequestId: string, name: string): void | Promise<void>;
  onToggleWaitingRoom(enabled: boolean): boolean | Promise<boolean>;
}

export interface PresenterHandlers {
  onGather(): void;
  onToggleFollow(active: boolean): boolean | Promise<boolean>;
}

export interface RoleHandlers {
  onSetRole(targetActorNr: number, targetName: string, role: string): Promise<void>;
}

export interface HudHandlers {
  moderation?: ModerationHandlers;
  lobby?: LobbyHandlers;
  presenter?: PresenterHandlers;
  role?: RoleHandlers;
}

const handlers: HudHandlers = {};
let followStop: (() => void) | null = null;

export function registerHandlers(patch: Partial<HudHandlers>): void {
  Object.assign(handlers, patch);
}

export function getHandlers(): Readonly<HudHandlers> {
  return handlers;
}

export function registerFollowStop(handler: (() => void) | null): void {
  followStop = handler;
}

export function getFollowStop(): (() => void) | null {
  return followStop;
}
